/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
import productActions from "../../../../Product/Product/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import CustomTable from "./CustomTable";
import TopBar from "./TopBar";
import moment from 'moment';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomForm from './CustomForm';
import actions from "../../redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { checkViewPermission } from '../../../../../helpers/utilities';
import unitActions from "../../../../Product/Setup/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";


const SalesPrice = React.forwardRef((props, ref) => {
    const { createDetails, createError, editDetails, editError, createData } = useSelector(state => state.crudReducer);
    const { maintainPriceDetails, maintainPriceLoader, unitMesurementdetails, productGroupDetails } = useSelector(state => state.productSetupReducer);

    const { productPrices } = useSelector(state => state.productProductReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);

    const { heads, title, topBarView, customerId, groupId, roleManagement, history } = props;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [error, setError] = useState({});
    const [commonError, setCommonError] = useState(false);
    const [form, setForm] = useState({});
    const [priceId, setPriceId] = useState('');
    const [dateValue, setDateValue] = useState([null, null]);
    const [status, setStatus] = useState('active');
    const [type, setType] = useState('ALL');
    const [deleteModal, setDeleteModal] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const dispatch = useDispatch();
    const [view, setView] = useState(false);
    const [visible, setVisible] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [topBar, setTopBar] = useState({
        type: 'All'
    });
    const [productChange, setProductChange] = useState(false);


    const handleKeyDown = (e) => {
        if (topBarView && e.altKey && e.keyCode === 78) {
            e.preventDefault();
            handleEmpty(true);
        } else if (topBarView && e.altKey && e.keyCode === 83) {
            e.preventDefault();
            if (visible) {
                handleSubmit(e);
            }
        } else if (topBarView && e.altKey && e.keyCode === 69) {
            e.preventDefault();
            if (visible && view) {
                onEdit(form);
            }
        }
    }

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Sales Price', history, 'Sales')) {
                dispatch({
                    type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                        order: 'id desc'
                    }
                });
                dispatch({
                    type: actions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups',
                    filter: {
                        order: 'id desc'
                    },
                });
                productApi();
            }
        }
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
        };
    }, [roleManagement]);


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Sales Price', history, 'Sales')) {
                dispatchFilter(dateValue, status, sortBy, sortOrder);
            }
        }
    }, [topBar, roleManagement]);

    useEffect(() => {
        setForm({
            'priceSpec': title.toUpperCase(),
            'productSpec': 'Product',
            'dynamicPrice': 'SALES PRICE',
            'customerSpec': 'ALL',
            'isActive': true
        });
    }, [title]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(dateValue, status, sortBy, sortOrder);
    }

    const dispatchFilter = (dateValue, status, sortBy, sortOrder, skip = 0, productId = '') => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { "and": [] };
        let or = { "or": [] }
        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ fromDate: { gte: moment(dateValue[0]).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(dateValue[1]).format('YYYY-MM-DD') } });
        }

        if (status) {
            filter['and'].push({ isActive: status === 'active' ? true : false });
        }

        if (topBar?.customerId || customerId) {
            //let cusOr = { "or": [] }
            if (customerId) {
                if (groupId) {
                    or['or'].push({ customerGroupId: groupId });
                }
                or['or'].push({ customerId: customerId });
            } else {
                filter['and'].push({ customerId: topBar?.customerId });
            }
        }

        if (type && type !== 'ALL') {
            filter['and'].push({ customerSpec: type });
        }

        if (topBar?.customerGroupId !== '') {
            filter['and'].push({ customerGroupId: topBar?.customerGroupId });
        }

        if (topBar?.productGroupId !== '') {
            filter['and'].push({ productGroupId: topBar?.productGroupId });
        }

        if (topBar?.search && topBar?.search !== '') {
            or['or'].push({ salesPriceId: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ priceSpec: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ customerSpec: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ lastPurchasePrice: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ margin: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ maxRetailPrice: { like: '%' + topBar?.search.trim() + '%' } });
        }

        if (topBar?.productId !== '') {
            filter['and'].push({ productId: topBar?.productId });
        }

        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'salesPriceAgreement',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx', exportType = 'export') => {
        let filter = { "and": [] };
        let or = { "or": [] };
        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ fromDate: { gte: moment(dateValue[0]).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(dateValue[1]).format('YYYY-MM-DD') } });
        }

        if (status !== '') {
            filter['and'].push({ isActive: status === 'active' ? true : false });
        }

        if (topBar?.customerId !== '') {
            filter['and'].push({ customerId: topBar?.customerId });
        }

        if (type !== '' && type !== 'ALL') {
            filter['and'].push({ customerSpec: type });
        }

        if (topBar?.customerGroupId !== '') {
            filter['and'].push({ customerGroupId: topBar?.customerGroupId });
        }

        if (exportType === 'import') {
            if (name === 'Customer Sales Price') {
                filter['and'].push({ dynamicPrice: "SALES PRICE" });
            } else if (name === 'Customer Margin Price') {
                filter['and'].push({ dynamicPrice: "MARGIN" });
            } else if (name === 'Customer Purch Price Markup') {
                filter['and'].push({ dynamicPrice: "PRICE-PURCHASE PRICE MARKUP" });
            } else {
                filter['and'].push({ dynamicPrice: "SALES PRICE BY-DISC ON MRP" });
            }
        }

        filter['and'].push(or);
        dispatch({
            type: actions.MAINTAIN_PRICE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            exportType: exportType,
            url: 'salesPriceAgreement',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(dateValue, status, sortBy, sortOrder, s);
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const onDelete = (data) => {
        setPriceId(data?.id);
        setForm({ ...data });
        setDeleteModal(true);
    }

    const onEdit = (data) => {
        setView(false);
        setPriceId(data?.id);
        setForm({ ...data });
        setVisible(true);
        productApi('', data?.productId);
        dispatch({
            type: productActions.PRODUCT_PRICE_START,
            url: `/purchasedprice/${data.productId}`
        });
    }

    const onView = (data) => {
        setView(true);
        setPriceId(data?.id);
        setForm({ ...data });
        productApi('', data?.productId);
        setVisible(true);
    }

    useEffect(() => {
        if (form?.dynamicPrice) {
            let price = 0;
            if (form?.cost) {
                price = form?.cost;
            } else {
                price = form?.lastPurchasePrice;
            }
            if (form?.dynamicPrice === 'SALES PRICE') {
                marginCalculation(form?.price, price);
            } else if (form?.dynamicPrice === 'MARGIN') {
                priceCalculation(form?.margin, price);
            } else if (form?.dynamicPrice === 'SALES PRICE BY-DISC ON MRP') {
                discountCalculation(form?.discountPercentage, form?.maxRetailPrice);
            } else {
                purchasePriceCalculation(form?.markup, price);
            }
        } else {
            setForm({
                ...form,
                'price': '',
                'margin': ''
            })
        }
    }, [form?.dynamicPrice, form?.cost, form?.lastPurchasePrice, form?.maxRetailPrice]);

    const discountCalculation = (percentage, mrp) => {
        let amount = (percentage / 100) * mrp;
        let data = {
            ...form,
            discountAmount: amount,
            price: mrp - amount,
        }
        let price = '';
        if (data?.cost) {
            price = data?.cost;
        } else {
            price = data?.lastPurchasePrice;
        }

        if (price > 0 && data?.price > 0) {
            let tPrice = ((data?.price - price) / data?.price) * 100;
            if (tPrice >= 0) {
                setError({
                    'margin': '',
                });
                data['margin'] = parseFloat(tPrice).toFixed(2);
            } else {
                setError({
                    'margin': 'Margin % is negative as the Selling Price is lower than Purchase/Cost price',
                });
                data['margin'] = parseFloat(tPrice).toFixed(2);
            }
        } else {
            data['margin'] = '';
        }
        setForm(data);
    }

    const marginCalculation = (price, cost) => {
        if (cost > 0 && price > 0) {
            let tPrice = ((price - cost) / price) * 100;
            if (tPrice >= 0) {
                setError({
                    'margin': '',
                });
                setForm({
                    ...form,
                    'margin': parseFloat(tPrice).toFixed(2)
                })
            } else {
                setError({
                    'margin': 'Margin % is negative as the Selling Price is lower than Purchase/Cost price',
                });
                setForm({
                    ...form,
                    'margin': parseFloat(tPrice).toFixed(2)
                    //'margin': ''
                });
            }
        } else {
            setForm({
                ...form,
                'margin': ''
            })
        }
    }

    const priceCalculation = (margin, cost) => {
        let sPrice = 0;
        if (cost > 0) {
            sPrice = cost / (1 - (margin / 100));
        } else {
            sPrice = cost / (margin / 100);
        }
        if (form?.dynamicPrice === 'MARGIN') {
            setForm({
                ...form,
                'markup': '',
                'price': parseFloat(sPrice).toFixed(2),
            });
        } else if (form?.dynamicPrice === 'PRICE-PURCHASE PRICE MARKUP') {
            setForm({
                ...form,
                'margin': '',
                'price': parseFloat(sPrice).toFixed(2),
            });
        }
    }

    const calculateMargin = (data) => {
        let cost = 0;
        if (data?.cost) {
            cost = data?.cost;
        } else {
            cost = data?.lastPurchasePrice;
        }
        let margin = '';
        //if (data?.dynamicPrice === 'SALES PRICE' || data?.dynamicPrice === '') {
        let price = data.price;
        if (cost > 0 && price > 0) {
            let tPrice = ((price - cost) / price) * 100;
            margin = parseFloat(tPrice).toFixed(2);
        }
        //}
        return margin && margin !== '' ? margin + '%' : ''
    }

    useEffect(() => {
        if (form?.discountPercentage && form?.dynamicPrice && form?.maxRetailPrice) {
            if (form?.dynamicPrice === 'SALES PRICE BY-DISC ON MRP') {
                discountCalculation(form?.discountPercentage, form?.maxRetailPrice);
            }
        } else if (form?.discountPercentage === '') {
            discountCalculation('', form?.maxRetailPrice);
        }
    }, [form.discountPercentage]);

    useEffect(() => {
        if (form?.price && form?.dynamicPrice && (form?.cost || form?.lastPurchasePrice)) {
            if (form?.dynamicPrice === 'SALES PRICE') {
                let price = '';
                if (form?.cost) {
                    price = form?.cost;
                } else {
                    price = form?.lastPurchasePrice;
                }
                marginCalculation(form?.price, price);
            }
        }
    }, [form?.price]);

    const purchasePriceCalculation = (markup, priceCal) => {
        let data = {
            ...form,
            'price': parseFloat(markup) + parseFloat(priceCal)
        }
        let price = 0;
        if (data?.cost) {
            price = data?.cost;
        } else {
            price = data?.lastPurchasePrice;
        }

        if (price > 0 && data?.price > 0) {
            let tPrice = ((data?.price - price) / data?.price) * 100;
            if (tPrice >= 0) {
                setError({
                    'margin': '',
                });
                data['margin'] = parseFloat(tPrice).toFixed(2);
            } else {
                setError({
                    'margin': 'Margin % is negative as the Selling Price is lower than Purchase/Cost price',
                });
                data['margin'] = parseFloat(tPrice).toFixed(2);
            }
        } else {
            data['margin'] = '';
        }
        setForm(data);
    }


    useEffect(() => {
        if (form?.dynamicPrice) {
            if (form?.dynamicPrice === 'PRICE-PURCHASE PRICE MARKUP') {
                let price = 0;
                if (form?.cost) {
                    price = form?.cost;
                } else {
                    price = form?.lastPurchasePrice;
                }

                purchasePriceCalculation(form?.markup, price);
                // if (form?.markup >= 100) {
                //     setError({
                //         'markup': 'Markup cannot be equal to or greater than 100 %. Please input a lower value.',
                //     });
                //     setForm({
                //         ...form,
                //         'price': 0
                //     });
                // } else {
                //     setError({
                //         'markup': '',
                //     });
                //     priceCalculation(form?.markup, price);
                // }
            }
        }
    }, [form.markup]);


    useEffect(() => {
        if (form?.dynamicPrice && (form?.cost || form?.lastPurchasePrice)) {
            if (form?.dynamicPrice === 'MARGIN') {
                let price = '';
                if (form?.cost) {
                    price = form?.cost;
                } else {
                    price = form?.lastPurchasePrice;
                }
                if (form?.margin >= 100) {
                    setError({
                        'margin': 'Margin cannot be equal to or greater than 100 %. Please input a lower value.',
                    });
                    setForm({
                        ...form,
                        'price': 0
                    });
                } else {
                    setError({
                        'margin': '',
                    });
                    priceCalculation(form?.margin, price);
                }
            }
        }
    }, [form?.margin]);

    const handleProductChange = (data) => {
        setForm({
            ...form,
            'productId': data?.id,
            'product': data,
            'unitId': data?.salesUnitId || '',
            'maxRetailPrice': data?.mrp ? parseInt(data?.mrp) : '',
            'cost': data?.costPrice || '',
            'useMRP': data?.useMrp ? true : false,
            // 'lastPurchasePrice': data?.latestPurchasePrice || 0
        });
        setError({});
        setProductChange(true);
        dispatch({
            type: productActions.PRODUCT_PRICE_START,
            url: `/purchasedprice/${data?.id || 0}`
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        handleSetProductPrice(form?.unitId, productChange);
    }, [productPrices]);

    const handleSetProductPrice = (unitId, productChange) => {
        if (productPrices && productPrices !== '' && productChange) {
            if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                productPrices?.lastprice[customObject(unitMesurementdetails, unitId)?.name]) {
                let result = productPrices?.lastprice[customObject(unitMesurementdetails, unitId)?.name];
                setForm({
                    ...form,
                    'lastPurchasePrice': result?.price,
                    'maxRetailPrice': result?.mrp
                });
            }
            setProductChange(false);
        }
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'useMRP') {
                setForm({
                    ...form,
                    [name]: !form?.useMRP,
                });
            } else if (name === 'unitId') {
                let productData = customObject(myProductdetails, form?.productId);
                let data = {};
                if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                    productPrices?.lastprice[customObject(unitMesurementdetails, e)?.name]) {
                    let result = productPrices?.lastprice[customObject(unitMesurementdetails, e)?.name];
                    data = {
                        'lastPurchasePrice': result?.price,
                        'maxRetailPrice': result?.mrp
                    };
                }
                setForm({
                    ...form, ...data,
                    [name]: e,
                    useMRP: productData?.salesUnitId !== e ? false : productData?.useMrp
                });

            } else if (name === 'specialExcisesDutyPercentage') {
                let mrpPercentage = (parseFloat(form?.maxRetailPrice || 0) * parseFloat(e)) / 100;
                setForm({
                    ...form,
                    [name]: e,
                    'specialExcisesDuty': parseFloat(mrpPercentage)
                });
            } else {
                setForm({
                    ...form,
                    [name]: e,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyProductId = emptyValidation('Product', form?.productId, 'dropDown');
        let emptyUnitId = emptyValidation('Unit', form?.unitId, 'dropDown');
        let emptyPrice = emptyValidation('Price', form?.price);
        let emptyDynamicPrice = emptyValidation('Dynamic Price', form?.dynamicPrice);
        // let emptyCostPrice = emptyValidation('Cost Price', form?.cost);
        // let emptyFromQuantity = quantityCheck('Quatity', form?.fromQuantity);
        // let emptyToQuantity = quantityCheck('Quatity', form?.toQuantity);
        let customerSpecification = true;
        let customer = true; let customerGroup = true;

        let emptySpecification = ''; let emptyCustomer = ''; let emptyCustomerGroup = '';

        emptySpecification = emptyValidation('Specification', form?.customerSpec, 'dropDown');
        if (!emptySpecification.isValid) {
            customerSpecification = false;
        }

        if (form?.customerSpec === 'SPECIFIC') {
            emptyCustomer = emptyValidation('Customer', form?.customerId, 'dropDown');
            if (!emptyCustomer.isValid) {
                customer = false;
            }
        } else if (form?.customerSpec === 'GROUP') {
            emptyCustomerGroup = emptyValidation('Customer Group', form?.customerGroupId, 'dropDown');
            if (!emptyCustomerGroup.isValid) {
                customerGroup = false;
            }
        }

        let checkPrice = { isValid: true, errors: '' };
        if (form?.useMRP && form?.maxRetailPrice !== '' && form?.maxRetailPrice !== null && (parseFloat(form?.price) > parseFloat(form?.maxRetailPrice))) {
            // if (form?.useMRP && form?.maxRetailPrice !== '' && form?.maxRetailPrice !== null && form?.price > form?.maxRetailPrice) {
            console.log('form?.price', form?.price, 'form?.maxRetailPrice', form?.maxRetailPrice);
            console.log('form?.product?.salesUnitId', form?.product?.salesUnitId, 'form?.unitId', form?.unitId);
            if (form?.product?.salesUnitId === form?.unitId) {
                checkPrice = { isvalid: false, errors: 'Sales price is greater than MRP Price' };
            }
        }

        let date = true;
        let fromDate = moment(form?.fromDate).format("YYYY-MM-DD");
        let toDate = moment(form?.toDate).format("YYYY-MM-DD");
        if (form?.fromDate && form?.toDate) {
            if (moment(toDate).diff(moment(fromDate), 'days') < 0) {
                date = false;
            }
        }
        let emptyMargin = { isValid: true, errors: '' };
        if (form?.price && (form?.cost || form?.lastPurchasePrice)) {
            let price = '';
            if (form?.cost) {
                price = form?.cost;
            } else {
                price = form?.lastPurchasePrice;
            }
            let tPrice = parseFloat(((form?.price - price) / form?.price) * 100);

            if (tPrice < 0 || tPrice >= 100) {
                emptyMargin = { errors: 'Invalid Margin', isValid: false };
            }
        }

        let emptyDiscountPercentage = { isValid: true, errors: '' };

        if (form?.dynamicPrice === 'SALES PRICE BY-DISC ON MRP') {
            emptyDiscountPercentage = emptyValidation('Discount Percentage', form?.discountPercentage);
        }

        let emptyPurchasePrice = { isValid: true, errors: '' };
        if (form?.dynamicPrice === 'PRICE-PURCHASE PRICE MARKUP') {
            emptyPurchasePrice = emptyValidation('Purch Price Markup', form?.markup);
        }

        if (form?.dynamicPrice === 'MARGIN') {
            emptyMargin = emptyValidation('Margin', form?.margin);
        }


        // if (form?.toQuantity < form?.fromQuantity) {
        //     emptyToQuantity = { errors: 'To Quantity is lesser than From Quantity', isValid: false };
        // }
        setError({});
        if (emptyProductId.isValid &&
            emptyUnitId.isValid &&
            emptyPrice.isValid && date &&
            emptyDynamicPrice.isValid && checkPrice.isValid && emptyMargin.isValid &&
            customerSpecification && customer && customerGroup && emptyDiscountPercentage.isValid && emptyPurchasePrice.isValid
        ) {
            delete form.id; delete form.createTs; delete form.product;
            delete form.customer; delete form.business; delete form.customerGroup; delete form.unit;

            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));

            if (data?.customerSpec === 'ALL') {
                data.customerId = undefined;
                data.customerGroupId = undefined;
            } else if (data?.customerSpec === 'SPECIFIC') {
                data.customerGroupId = undefined;
            } else if (data?.customerSpec === 'GROUP') {
                data.customerId = undefined;
            }
            if (data?.margin) {
                data.margin = parseFloat(data?.margin);
            }

            if (data?.dynamicPrice !== 'SALES PRICE BY-DISC ON MRP') {
                data.discountPercentage = 0;
                data.discountAmount = 0;
            }

            if (data?.maxRetailPrice) {
                data.maxRetailPrice = parseFloat(data?.maxRetailPrice);
            }

            if (data?.specialExcisesDutyPercentage) {
                data.specialExcisesDutyPercentage = parseFloat(data?.specialExcisesDutyPercentage);
            }

            if (data?.specialExcisesDuty) {
                data.specialExcisesDuty = parseFloat(data?.specialExcisesDuty);
            }

            if (data?.price) {
                data.price = parseFloat(form?.price);
            }

            if (data?.discountPercentage) {
                data.discountPercentage = parseFloat(form?.discountPercentage);
            }

            if (data?.markup) {
                data.markup = parseFloat(form?.markup);
            }

            if (data?.lastPurchasePrice) {
                data.lastPurchasePrice = parseFloat(form?.lastPurchasePrice);
            }

            if (data?.cost) {
                data.cost = parseFloat(form?.cost);
            }

            if (data?.fromDate) {
                data.fromDate = moment(data?.fromDate).format("YYYY-MM-DD")
            }

            if (data?.toDate) {
                data.toDate = moment(data?.toDate).format("YYYY-MM-DD")
            }

            dispatch({
                type: priceId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "salesPriceAgreement",
                title: "Sales Price",
                method: "put",
                id: priceId,
                details: data
            })
        } else {
            setError({
                'productId': emptyProductId.errors,
                'unitId': emptyUnitId.errors,
                'price': emptyPrice.errors || checkPrice.errors,
                'dynamicPrice': emptyDynamicPrice.errors,
                'margin': emptyMargin.errors,
                'customerSpec': emptySpecification.errors,
                'customerId': emptyCustomer.errors,
                'customerGroupId': emptyCustomerGroup.errors,
                'discountPercentage': emptyDiscountPercentage.errors,
                'markup': emptyPurchasePrice.errors,
                'toDate': date ? '' : 'To date is not lesser than from date'
            })
        }
    }

    const handleEmpty = (d) => {
        setVisible(d);
        setError({});
        setView(false);
        setForm({
            'priceSpec': title.toUpperCase(),
            'productSpec': 'Product',
            'dynamicPrice': 'SALES PRICE',
            'customerSpec': 'ALL', 'isActive': true
        });
        productApi();
        setCommonError(false);
        setPriceId('');
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (createData?.error?.message) {
                setCommonError(createData?.error?.message);
            } else {
                toast.dismiss();
                toast(createDetails);
                handleEmpty(false); dispatchFilter(dateValue, status, sortBy, sortOrder);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            setCommonError(message);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (!customerId && prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            handleEmpty(false); dispatchFilter(dateValue, status, sortBy, sortOrder);
        } else if (!customerId && prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError?.error?.message;
            setCommonError(message);
        }
    }, [editDetails, editError]);

    const handleDates = (value) => {
        setDateValue(value);
        dispatchFilter(value, status, sortBy, sortOrder);
    }

    const handleStatus = (value) => {
        setStatus(value);
        dispatchFilter(dateValue, value, sortBy, sortOrder);
    }

    const handleCopy = (data) => {
        setView(false);
        setPriceId('');
        setForm({ ...data });
        setVisible(true);
    }

    const handleDeactive = (data) => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "salesPriceAgreement",
            title: "Sales Price",
            id: data?.id,
            details: {
                'isActive': !data?.isActive
            }
        })
    }

    useImperativeHandle(ref, () => ({
        dispatchFilter(productId) {
            dispatchFilter(dateValue, status, sortBy, sortOrder, skip, productId)
        }
    }));

    const handleFilter = (data) => {
        if (data?.startDate && data?.endDate) {
            setDateValue([data?.startDate, data?.endDate]);
        } else {
            setDateValue([null, null])
        }
        setTopBar(data);
    }


    return (
        <React.Fragment>
            <TopBar
                topBarView={topBarView}
                onImportVisible={(v) => setImportVisible(v)}
                loadImportExportData={(name) => loadImportExportData(name)}
                roleManagement={roleManagement}
                handleFilter={(customerId, customerGroupId, productId, search = '') =>
                    setTopBar({
                        'customerId': customerId, 'customerGroupId': customerGroupId, 'productId': productId, 'search': search
                    })}
                topBar={topBar}
                dateValue={dateValue}
                handleSideFilter={(data) => handleFilter(data)}
                title={title}
                handleType={(value) => setType(value)}
                handleStatus={(value) => handleStatus(value)}
                handleDatesParent={(value) => handleDates(value)}
                handleCreate={() => handleEmpty(true)}
                maintainPriceLoader={maintainPriceLoader}
                maintainPriceDetails={maintainPriceDetails}
                limit={limit}
                sortBy={sortBy}
                sortOrder={sortOrder}
                groupId={groupId}
                productGroupDetails={productGroupDetails}
                productApi={(s = '', id = '') => productApi(s, id)}
            />
            <CustomTable
                heads={heads}
                status={status}
                topBar={topBar}
                roleManagement={roleManagement}
                handleDeactive={(data) => { handleDeactive(data) }}
                sortOrder={sortOrder}
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                loadMoreTask={() => loadMoreTask()}
                details={customerId ? getList && getList?.filter((item) => {
                    return item.fromDate > moment().format('YYYY-MM-DD') || item.toDate > moment().format('YYYY-MM-DD') || item.toDate === null || item.fromDate === null;
                }) : getList}
                sortBy={sortBy}
                dateValue={dateValue}
                type={customerId ? 'singleCustomer' : type}
                {...props}
                calculateMargin={(data) => calculateMargin(data)}
                onEdit={(data) => onEdit(data)}
                onView={(data) => onView(data)}
                onDelete={(data) => onDelete(data)}
                handleCopy={(data) => handleCopy(data)}
                handleCreate={() => handleEmpty(true)}
                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
            />
            <CustomForm
                customerId={customerId}
                roleManagement={roleManagement}
                changeHandler={(e, fieldName) => changeHandler(e, fieldName)}
                handleProductChange={(data) => handleProductChange(data)}
                handleIsActive={(data) => setForm({ ...form, "isActive": data })}
                form={{ ...form }}
                title={title}
                view={view}
                priceId={priceId}
                error={{ ...error }}
                customObject={(details, id) => customObject(details, id)}
                commonError={commonError}
                handleSubmit={(e) => handleSubmit(e)}
                handleClose={() => handleEmpty(false)} visible={visible}
                handleEdit={(d) => setView(d)}
                productApi={(s = '', id = '') => productApi(s, id)}
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={priceId} loadTasks={() => dispatchFilter(dateValue, status, sortBy, sortOrder)}
                name={form?.salesPriceId} url={'salesPriceAgreement'}
                title={'Sales Price'} visible={deleteModal}
            />
            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={"Customer Sales Price"}
                type={'import'}
                loader={maintainPriceLoader}
                loadImportExportData={(name, type, selected, extension, exportType) => loadImportExportData(name, type, selected, extension, exportType)}
                details={maintainPriceDetails}
                loadTasks={() => dispatchFilter(dateValue, status, sortBy, sortOrder)}
            />
        </React.Fragment>
    )
})

export default SalesPrice
